import styled from 'styled-components';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { colors, size } from './styles/variables';
import { Flex, Block } from './styles/blocks';
import logo from '../public/icons/drip-studio.svg';
import rarity from '../public/icons/raritysniper.png';
import Link from 'next/link';

const AppFooter = styled.footer`
  position: absolute;
  bottom: 0;
  width: 100%;
  
  .mobile-box {
    display: none;
  }
  .pirates-box {
    text-align: center !important;
    width: 100%;
  }
  font-size: 14px;
  color: ${colors.lightPink};
  font-weight: 700;
  a {
    color: ${colors.lightPink};
    text-decoration: none;
  }
  .rarity-box {
    font-size: 12px;
  }
  @media (max-width: ${size.md}) {
    position: relative;
    margin-top: 30px;
    .desktop-box {
      display: none;
    }
    .mobile-box {
      display: block;
      font-size: 12px;
      padding-top: 15px;
    }
    .rarity-box {
      width: 100%;
      padding: 10px 0 20px 0 !important;
    }
  }
`;

export default function Footer() {
  const { t } = useTranslation('common');
  const RarityBox = (
    <Flex
      fd="row"
      ai="center"
      as="a"
      href="https://raritysniper.com/pirates-of-the-metaverse"
      target="_blank"
      className="rarity-box"
      width="100%"
      jc="center"
    >
      <Image height="30px" width="30px" src={rarity} alt="Rarity Sniper" />
      <Block marginL="10px" marginSmL="5px" marginR="10px">
        <p>
          {t('footer.rankingsLabel')}
          Rarity Sniper
        </p>
      </Block>
    </Flex>
  );

  const PiratesBox = (
    <Block
      fontSize="12px"
      className="pirates-box"
    >
      <Block as="p" alignMd="left">© 2022 PIRATES OF THE METAVERSE&trade; by <a href="https://www.dripstudios.io/" target="_blank" rel="noreferrer">Drip Studios</a> </Block>
      <Flex jc="center" jcMd="space-between" paddingY="8px">
        <Block paddingX="65px" paddingMd="0"><a href="mailto:ello@dripstudios.io">hello@dripstudios.io</a></Block>
        <Block paddingX="65px" paddingMd="0">
          <Link  href="/legal">
            <a>Legal Notice</a>
          </Link>
        </Block>
      </Flex>
    </Block>
  );

  const DripBox = (
    <Block
      as="a"
      href="https://www.dripstudios.io/"
      target="_blank"
      width="100%"
      className="text-sm-center text-end"
    >
      <Image
        height="35px"
        width="60px"
        src={logo}
        color={colors.lightPink}
        alt="Drip Studios"
      />
    </Block>
  );

  return (
    <AppFooter>
      <Block className="mobile-box">
        <Block paddingR="5%" paddingL="5%">
          {PiratesBox}
        </Block>
        <Flex wrap="no-wrap" ai="space-between" paddingR="5%" paddingL="5%">
          {RarityBox}
          {DripBox}
        </Flex>
      </Block>
      <Flex
        jc="space-between"
        fd="row"
        ai="center"
        wrap="no-wrap"
        padding="1% 10% 1% 10%"
        className="desktop-box"
        paddingT="20px"
      >
        <>
          {RarityBox}
          {PiratesBox}
          {DripBox}
        </>
      </Flex>
    </AppFooter>
  );
}
